import React from 'react';
import './SecTitle.css'

const SecTitle = (props) => {

    return ( 
        <div className='SecTitle'>
            <p className='TitleText'><span className='Purple'>{props.TitleText1}</span> {props.TitleText2}</p>
            <p className='TitleSub'>{props.TitleSub}</p>
        </div>
     );
}
 
export default SecTitle;